import { formatDate } from '@angular/common';
import { ApplicationRef, Component, ComponentFactoryResolver, Injector, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
declare const L: any;
import 'leaflet-draw';
import { LatLng } from 'leaflet';
import { Router } from '@angular/router';
import { MapPopupComponent } from '../map-popup/map-popup.component';

interface EventItem {
  status?: string;
  date?: string;
  icon?: string;
  color?: string;
  image?: string;
}


@Component({
  selector: 'app-user-tracking',
  templateUrl: './user-tracking.component.html',
  styleUrls: ['./user-tracking.component.css']
})
export class UserTrackingComponent implements OnInit {

  private map!: L.Map;
  private centroid: L.LatLngExpression = [42.3601, -71.0589];
  // private centroid1: L.LatLngExpression = [32.3601, -31.0589];
  usersList: any = []
  usertrackingList: any = []
  allUsersList: any = []
  cid: any
  date1: any
  date2: any
  search = ""
  useremail: any;
  username: any;
  lat: any = [];
  lon: any = [];
  name: any = "";

  geojsonData: any = {
    "type": "FeatureCollection",
    "features": []
  }

  feature: any = {
    "type": "Feature",
    "color": "black",
    "properties": {
      "name": "Polygon 1"
    },
    "geometry": {
      "coordinates": [],
      "type": "LineString"
    }
  }
  features: any = []
  employeeLocationsData: any = []


  events: any = [];

  locationList: any = []
  locationFilterList: any = []
  userCred: any;
  userLocations: any = []

  constructor(
    private resolver: ComponentFactoryResolver,
    private appRef: ApplicationRef, private router: Router,
    private injector: Injector,
    private fb: FormBuilder, private toastr: ToastrService, private generic_service: GenericService) { }

  ngOnInit(): void {

    this.cid = sessionStorage.getItem('cid')
    this.getUsersWithoutCustomers()
    this.date2 = new Date()
    this.date2.setDate(this.date2.getDate() + 1);
    this.date2 = formatDate(this.date2, 'yyyy-MM-dd', 'en-US')
    console.log(new Date(this.date2).getTime())
    this.date1 = new Date()
    this.date1 = formatDate(new Date(), 'yyyy-MM-dd', 'en-US')
    this.userCred = JSON.parse(sessionStorage.getItem('userCreds')!);
    this.getAllLocation()
  }

  getAllLocation() {
    this.generic_service.getAllLocation().subscribe(
      (res: any) => {
        this.locationList = res.response

        this.locationFilterList = (this.locationList?.filter((location: any) =>
          this.userCred?.locations?.includes(location.locationId)
        )) || [];
        console.log(this.locationFilterList)

        this.userLocations = this.locationFilterList.map((item: any) => item.zone);
        console.log(this.userLocations)
      },
      (err: any) => {
        console.log(err)
      }
    )
  }

  private centroid1: L.LatLngExpression[] = [];

  hyderabadLoc: L.LatLngExpression[] = [[17.3850, 78.4867]]

  private initMap(): void {
    console.log("initMap")
    this.events = []
    let ct: any = [this.hyderabadLoc[0]]

    if (this.employeeLocationsData.length != 0) {
      this.map = L.map('map', {
        center: [this.employeeLocationsData[0].latitude, this.employeeLocationsData[0].longitude],
        zoom: 16
      });
    } else {
      this.map = L.map('map', {
        center: ct[0],
        zoom: 16
      });
    }

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 28,
      minZoom: 2,
      attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    });

    tiles.addTo(this.map);


    if (this.employeeLocationsData.length != 0) {

      let feature: any = {
        "type": "Feature",
        "color": "black",
        "properties": [],
        "geometry": {
          "coordinates": [],
          "type": "LineString"
        }
      }

      for (let i = 0; i < this.employeeLocationsData.length; i++) {

        this.employeeLocationsData[i].currentDate = formatDate(this.employeeLocationsData[i].currentDateTime, 'hh:mm:ss a', 'en-US')
        let location: any = [
          this.employeeLocationsData[i].longitude,

          this.employeeLocationsData[i].latitude
        ]

        feature.geometry.coordinates.push(location)
      }

      this.geojsonData.features.push(feature)
      this.geojsonData.properties = this.employeeLocationsData

      console.log(this.geojsonData)
      console.log(this.employeeLocationsData)


      this.geojsonData.features.forEach((feature: any) => {
        const layer = L.geoJSON(feature, {
          style: {
            color: "black",
            weight: 7
          }
        }).addTo(this.map)



        //  if (feature.geometry.type === 'LineString') {
        //   const coords = feature.geometry.coordinates;
        //   const midIndex = Math.floor(coords.length / 2);
        //   const midCoord = coords[midIndex]; 

        //   const customIcon = L.icon({
        //     iconUrl: 'assets/img/dummy-image.jpeg', 
        //     iconSize: [42, 42],                      
        //     iconAnchor: [26, 52],                   
        //   });

        //   L.marker([midCoord[1], midCoord[0]], { icon: customIcon }).addTo(this.map);
        // }


        if (feature.geometry.type === 'LineString') {
          // Create a custom image marker but do NOT add it yet
          const hoverMarker = L.marker([0, 0], {
            icon: L.divIcon({
              className: '',
              html: `
          <div style="
            position: relative;
            width: 40px;
            height: 40px;
            background: white;
            border: 2px solid #2c3e50;
            border-radius: 50%;
            overflow: hidden;
            box-shadow: 0 1px 4px rgba(0,0,0,0.3);
          ">
            <img src="assets/img/dummy-image.jpeg" style="width: 100%; height: 100%; object-fit: cover;" />
          </div>
        `,
              iconAnchor: [20, 20],
            }),
            interactive: false // so it doesn't block mouse events
          });

          // Mouse move on line — update marker position and add to map
          layer.on('mousemove', (e: any) => {
            const latlng = e.latlng;
            hoverMarker.setLatLng(latlng);

            if (!this.map.hasLayer(hoverMarker)) {
              hoverMarker.addTo(this.map);
            }
          });

          // Remove marker when mouse leaves line
          layer.on('mouseout', () => {
            if (this.map.hasLayer(hoverMarker)) {
              this.map.removeLayer(hoverMarker);
            }
          });
        }


        if (feature.geometry.type === 'LineString') {
          const coords = feature.geometry.coordinates;

          if (coords.length > 0) {
            const lastCoord = coords[coords.length - 1];
            const firstCoord = coords[0];
            console.log(firstCoord)
            console.log(lastCoord)

            // Custom styled image marker using HTML
            const customHtmlIcon = L.divIcon({
              className: '',
              html: `
          <div style="
            position: relative;
            width: 60px;
            height: 60px;
            background: white;
            border: 3px solid #4DF02D;
            border-radius: 50%;
            overflow: hidden;
            box-shadow: 0 2px 6px rgba(0,0,0,0.3);
          ">
            <img src="assets/img/dummy-image.jpeg" style="width: 100%; height: 100%; object-fit: cover;" />
            <div style="
              position: absolute;
              bottom: -10px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              border-top: 15px solid #2c3e50;
            "></div>
          </div>
        `,
              iconAnchor: [30, 64], // Center bottom of marker
              popupAnchor: [0, -60]
            });

            const customHtmlIcon1 = L.divIcon({
              className: '',
              html: `
          <div style="
            position: relative;
            width: 60px;
            height: 60px;
            background: white;
            border: 3px solid #FB232E;
            border-radius: 50%;
            overflow: hidden;
            box-shadow: 0 2px 6px rgba(0,0,0,0.3);
          ">
            <img src="assets/img/dummy-image.jpeg" style="width: 100%; height: 100%; object-fit: cover;" />
            <div style="
              position: absolute;
              bottom: -10px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border-left: 10px solid transparent;
              border-right: 10px solid transparent;
              border-top: 15px solid #2c3e50;
            "></div>
          </div>
        `,
              iconAnchor: [30, 64], // Center bottom of marker
              popupAnchor: [0, -60]
            });



            const marker = L.marker([lastCoord[1], lastCoord[0]], {
              icon: customHtmlIcon
            }).addTo(this.map);

            const last_marker = L.marker([firstCoord[1], firstCoord[0]], {
              icon: customHtmlIcon1
            }).addTo(this.map);

            const newCoords = this.employeeLocationsData.slice(1, coords.length - 1);
            // const newCoords1 = newCoords.slice(1, coords.length - 1);

            // console.log("Original:", coords);
            // console.log("Middle (skipping first & last):", newCoords);

            for (let list of newCoords) {


              const customHtmlIcon2 = L.divIcon({
                className: '',
                html: `
        <div style="
          position: relative;
          width: 20px;
          height: 20px;
          background: white;
          border: 3px solid #ffffff;
          border-radius: 50%;
          overflow: hidden;
          box-shadow: 0 2px 6px rgba(0,0,0,0.3);
        ">
          <img src="assets/img/dummy-image.jpeg" style="width: 100%; height: 100%; object-fit: cover;" />
          <div style="
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            font-size: 10px;
            color: black;
            background: rgba(255,255,255,0.7);
            text-align: center;
          ">
          </div>
          <div style="
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 0;
            height: 0;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            border-top: 15px solid #2c3e50;
          "></div>

        </div>
        <div style="
        margin-left: -20px;
        margin-top: 0;
        font-size: 14px;
        color: black;
        white-space: nowrap;
      ">
        ${list.currentDate}
      </div>
            

      `,
                iconAnchor: [0, 5], // adjust based on your design
                popupAnchor: [0, -60]
              });

              L.marker([list.latitude, list.longitude], { icon: customHtmlIcon2 }).addTo(this.map);
            }


            // marker.bindPopup(`
            //   <div style="text-align: center;">
            //     <img src="assets/img/dummy-image.jpeg" style="width: 150px; border-radius: 8px;" />
            //     <p>End of the route</p>
            //   </div>
            // `);
          }
        }

      });


    }






  }

  // defaultIcon = L.icon({
  //   iconUrl: 'assets/4899329.png',
  //   iconSize: [80, 80],
  //   iconAnchor: [2, 2],
  //   popupAnchor: [40, -4]
  // });

  // defaultIcon = L.icon({
  //   iconUrl: 'assets/image_2024_10_31T14_54_50_870Z.png',
  //   iconSize: [80, 80],
  //   iconAnchor: [2, 2],
  //   popupAnchor: [40, -4]
  // });



  defaultIcon = L.icon({
    iconUrl: 'assets/icons8-location-96.png',
    iconSize: [50, 50],
    iconAnchor: [2, 2],
    popupAnchor: [40, -4]
  });

  ngOnDestroy() {
    console.log("ngOnDestroy")
    this.map.remove();
  }

  // getUsers(){
  //   this.generic_service.getUsers().subscribe(
  //     (res:any)=>{
  //       this.usersList = res.response;
  //       console.log(this.usersList)
  //     }
  //   )
  // }

  getUsersWithoutCustomers() {
    this.generic_service.getUsersWithoutCustomers().subscribe(
      (res: any) => {

        let list: any = []

        for (let i = 0; i < res.response.length; i++) {

          if (res.response[i].keyValues != null && res.response[i].keyValues.length != 0 && res.response[i].keyValues != undefined) {
            for (let j = 0; j < res.response[i].keyValues.length; j++) {
              if (res.response[i].keyValues[j].key.toLowerCase() == "usertracking") {
                if (res.response[i].keyValues[j].value.toLowerCase() == "true") {
                  list.push(res.response[i])
                }
              }
            }
          }
        }
        this.usertrackingList = list;
        this.usersList = list
        this.allUsersList = res.response;
        this.initMap();
      }
    )
  }

  usersChange(isOnSite: any) {
    let payload = {
      "locations": this.userLocations,
      "isOnSite": isOnSite,
      "cid": Number(this.cid) || 0
    };

    this.generic_service.getUsersByMultipleLocationsAndIsOnSiteAndCid(payload).subscribe(
      (res: any) => {
        if (!res.error) {
          this.usersList = res.response || [];
        } else {
          this.usersList = [];
        }
      },
      (err: any) => {
        console.error(err);
        this.usersList = [];
      }
    );
  }

  getName(event: any) {
    console.log(event)
  }

  getEmployeeLocationTrackingByIdAndBetweenDates(userId: any, event: any) {
    this.name = event.target.innerText
    this.generic_service.getEmployeeLocationTrackingByIdAndBetweenDates(userId, new Date(this.date1).getTime(), new Date(this.date2).getTime()).subscribe(
      (response: any) => {
        console.log(response)
        let locationsDataList: any = []
        for (let list of response.response) {

          if (list.latitude != null && list.longitude != null && list.latitude != 0 && list.longitude != 0 && list.latitude != '' && list.longitude != '') {
            locationsDataList.push(list)
          }
        }
        this.employeeLocationsData = locationsDataList

        console.log(this.employeeLocationsData)

        this.map.remove();
        // this.centroid1 = []
        // console.log(res)
        // console.log(res.response)

        // let obj:any = {
        //   "type": "Feature",
        //   "layerColor": "RED",
        //   "properties": {
        //     "name": "line"
        //   },
        //   "geometry": {
        //     "type": "LineString"
        //   }
        // }

        // let latlang: L.LatLngExpression[] = []

        // if(res.response != null && res.response.length != 0){
        //   for(let i = 0; i < res.response.length; i++){
        //     if(res.response[i].latitude != null && res.response[i].latitude != "" && res.response[i].latitude != undefined){
        //       let ct:any = [res.response[i].latitude,res.response[i].longitude]
        //       this.centroid1.push(ct)

        //       latlang.push(
        //         [
        //           parseFloat(res.response[i].longitude),
        //           parseFloat(res.response[i].latitude)
        //         ]
        //       )
        //     }
        //   }
        //   obj.geometry.coordinates = latlang;
        //   obj.geometry.type = "LineString";
        //   this.features.push(obj)

        // }else{

        // }
        // console.log(this.features)
        // console.log(this.centroid1)
        // this.geojsonData = this.features

        this.initMap()

      },
      (error: any) => {
        console.log(error)
      }
    )
  }

  getEmployeLocation(useremail: any, event: any) {

    console.log(event)
    this.name = event.target.__ngContext__[22]

    let body = {
      "startDate": new Date(this.date1).getTime(),
      "endDate": new Date(this.date2).getTime(),
      "cid": this.cid,
      "username": useremail
    }

    console.log(body)
    this.generic_service.getAllByCidAndBetweenDates(body).subscribe(
      (res: any) => {
        this.map.remove();
        this.centroid1 = []
        console.log(res)
        console.log(res.response)

        if (res.response.length != 0) {
          for (let i = 0; i < res.response.length; i++) {
            let ct: any = [res.response[i].latitude, res.response[i].longitude]
            this.centroid1.push(ct)
          }
          this.initMap()
        } else {
          //  this.centroid1.push([17.3850, 78.4867])
          this.initMap()

        }
        console.log(this.centroid1)

      },
      (err: any) => {
        console.log(err)
      }
    )
  }



  compilePopup(component: any, onAttach: any): any {
    const compFactory: any = this.resolver.resolveComponentFactory(component);
    let compRef: any = compFactory.create(this.injector);

    // onAttach allows you to assign 
    if (onAttach)
      onAttach(compRef);

    this.appRef.attachView(compRef.hostView);
    compRef.onDestroy(() => this.appRef.detachView(compRef.hostView));

    let div = document.createElement('div');
    div.appendChild(compRef.location.nativeElement);
    return div;
  }
}